module.exports = __webpack_public_path__ + "static/img/group-5.a037e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-5.png
// module id = W7DV
// module chunks = 15